import { IHealthProcedures, Physician } from '../healthProcedures'

export interface IGetNewbornScreeningParams {
  patientId: number | null
}

export enum ENewbornScreeningTestCode {
  HEARING_SCREENING_CODE = 22157221,
  TONGUE_TEST_CODE = 23512402,
  EYE_SCREENING_CODE = 23417769,
  PULSE_OXIMETRY_SCREENING_CODE = 127184008,
  PULSE_OXIMETRY_SCREENING_CODE_1 = 21932262,
  PULSE_OXIMETRY_SCREENING_CODE_2 = 21681857,
  PULSE_OXIMETRY_SCREENING_CODE_3 = 21681853,
  HEEL_PRICK_TEST_CODE_1 = 26023925,
  HEEL_PRICK_TEST_CODE_2 = 22130262,
  HEEL_PRICK_TEST_CODE_3 = 124246710,
  IMMUNO_ANALYSIS_CODE = 26788724,
  IMMUNODEFICIENCY_PANEL_CODE = 28976690,
  SMA_PANEL_CODE = 26023552,
  QUALITATIVE_TANDEM_CODE = 124301380,
  QUANTITATIVE_TANDEM_CODE = 124648406,
  LYMPHOPENIAS_CODE = 125867981,
  SOMMOS_DNA_TEST_CODE = 333845616,
  SCIDS_CODE = 78480085,
  LYSOSOMIC_SCREENING_CODE = 232990840,
  ELA_SCREENING_CODE = 274733013
}

export interface MedicalTest extends IHealthProcedures {
  patientId: number
  responsiblePhysician: Physician
  referringPhysician: Physician
  code?: number
}

export interface INewbornScreeningTest extends MedicalTest {
  properties: NewbornScreeningTestProperty[]
}

export interface NewbornScreeningTestProperty {
  name: string
  result: string
  referenceValue: string
}
